import React from "react";
import { withState, compose } from "recompose";
import moment from "moment";
import styled from "styled-components";

export default compose(
  withState("isExpanded", "setExpanded", false),
  withState("selected", "setSelected", null)
)(
  ({
    slots,
    isExpanded,
    selected,
    setSelected,
    setExpanded,
    onBookSlot,
    onSlotChange
  }) => (
    <Wrap>
      {slots.length > 0 ? (
        <React.Fragment>
          <Title>
            Choose a time <span>(Eastern-EST)</span>
          </Title>
          <Slots>
            {slots.map((slot, i) => {
              return (
                <SlotWrap key={i}>
                  <Slot
                    isSelected={selected === i}
                    onClick={() => {
                      setSelected(i);
                      onSlotChange(slot.id);
                    }}
                  >
                    {moment(slot.time).format("h:mm A")}
                  </Slot>
                </SlotWrap>
              );
            })}
          </Slots>
        </React.Fragment>
      ) : (
        <div>Sorry, there is no free timeslots for the selected date</div>
      )}
    </Wrap>
  )
);

const Wrap = styled.div`
  padding: 2rem 0 3rem;
  @media (max-width: 680px) {
    padding: 2rem 1rem;
    margin: 1rem 0;
    background: #fff;
  }
`;

const Title = styled.div`
  margin-bottom: 1rem;
  font-family: "CircularStd-Book", sans-serif;
  span {
    color: #cccccc;
  }
`;

const Slot = styled.div`
  border: 1px solid #e6e5e0;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.75rem 1.25rem;
  font-family: "CircularStd-Book", sans-serif;
  @media (max-width: 768px) {
    height: 3rem;
  }
  &:hover {
    color: #fff;
    border-color: #f76367;
    background-color: #f76367;
    font-family: "CircularStd-Bold", sans-serif;
  }
  ${({ isSelected }) =>
    isSelected &&
    `
    font-family: "CircularStd-Bold", sans-serif;
    border-color: #f76367;
    background-color: #f76367;
    color: #fff;
  `};
`;

const SlotWrap = styled.div`
  padding: 0.3rem;
  width: ${100 / 7}%;
  @media (max-width: 768px) {
    width: ${100 / 3}%;
  }
`;

const Slots = styled.div`
  margin: -0.3rem;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 2.5rem;
  @media (max-width: 680px) {
    padding-bottom: unset;
  }
`;

const MoreLink = styled.div`
  text-decoration: underline;
  text-transform: uppercase;
  margin-top: 2rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  color: #ababab;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/components/ChooseDate/TimeSlot.js